import { Box, Link, Text, Image, GridItem, Stack } from "@chakra-ui/react";
import { IEventResponseModel } from "../models/library.models";
import CalendarIcon from "../assets/images/icons/Icon-Custom-Small-Grey-Calendar.svg";
import TicketIcon from "../assets/images/icons/Icon-Small-Grey-Ticket.svg";
import LocationIcon from "../assets/images/icons/Icon-Custom-Small-Grey-Location.svg";
import BookIcon from "../assets/images/icons/Icon-Small-Grey-Weekly tag.svg";
import MonthlyIcon from "../assets/images/icons/Icon-Small-Grey-Monthly tag.svg";
import ArrowIcon from "../assets/images/icons/Icon-Medium-Grey-Arrow-right.svg";

type EventBoxProps = IEventResponseModel & {
  size: "small" | "large";
  colSpan: number;
};

/*
 * A Default template for an event display box
 * This component is used for displaying event cards within the content pages.
 */
export default function EventBox(props: EventBoxProps) {
  // Parse and format the date for event into easy readability
  var parsedDate = new Date(props.date);
  var dayName = parsedDate.toLocaleDateString("en-AU", { weekday: "short" });
  var monthName = parsedDate.toLocaleDateString("en-AU", { month: "short" });

  const { colSpan, size } = props;
  const isWiderEvent = size === "large";
  const imgClassName = isWiderEvent
    ? "event-box-image"
    : "event-box-image-small";
  const gridClassName = "event-box-container";

  return (
    <GridItem colSpan={colSpan} className={gridClassName}>
      <Link
        href={props.hyperlink}
        isExternal
        _hover={{ textDecoration: "none" }}
      >
        <Stack gap="0" h="100%">
          <Image src={props.image} alt={props.image} className={imgClassName} />
          {props.bookingLink && <BookingInfoBadge />}
          {!props.bookingLink && props.repeatType !== "none" && (
            <InfoBadge repeatType={props.repeatType} />
          )}
          <Stack m="20px" gap="12px" h="100%">
            <Text textStyle="body-label">
              {props.productTypeName.join(", ")}
            </Text>
            <Text
              textStyle="h4"
              dangerouslySetInnerHTML={{ __html: props.title }}
            ></Text>
            <Stack direction="row">
              <img src={CalendarIcon} alt="Calendar Icon" />
              <Text textStyle="body-regular">
                {dayName} {parsedDate.getDate()} {monthName}
                {props.startTime && (
                  <> at {props.startTime.replace(".00", "").replace(" ", "")}</>
                )}
              </Text>
            </Stack>
            <Stack direction="row">
              <img src={LocationIcon} alt="Location Icon" />
              <Text textStyle="body-regular">
                {props.city}
              </Text>
            </Stack>
            <Text
              textStyle="body-regular"
              noOfLines={2}
              dangerouslySetInnerHTML={{ __html: props.description }}
            ></Text>
            <Box mt="auto">
              <Link href={props.hyperlink} isExternal>
                <img src={ArrowIcon} alt="Arrow Icon" width="18px" />
              </Link>
            </Box>
          </Stack>
        </Stack>
      </Link>
    </GridItem>
  );
}

/*
 * Booking information badge component.
 * This component is used ticketed events.
 */
function BookingInfoBadge() {
  return (
    <Box className="event-box-badge-container">
      <Box backgroundColor="#FFEAC6" className="event-box-badge">
        <Stack direction="row" style={{ alignItems: "center" }}>
          <img src={TicketIcon} alt="Ticket Icon" />
          <Text textStyle="body-label">
            Ticketed&nbsp;
          </Text>
        </Stack>
      </Box>
    </Box>
  );
}

/*
 * Information badge component.
 * This component is used weekly and monthly re-occuring events.
 */
function InfoBadge({ repeatType }) {
  return (
    <Box className="event-box-badge-container">
      <Box
        backgroundColor={repeatType === "week" ? "#FFDBFB" : "#D9F1FB"}
        className="event-box-badge"
      >
        <Stack direction="row">
          {repeatType === "week" ? (
            <img src={BookIcon} alt="Book Icon" />
          ) : (
            <img src={MonthlyIcon} alt="Book Icon" />
          )}
          <Text textStyle="body-label">
            {repeatType === "week" ? "Weekly" : "Monthly"} &nbsp;
          </Text>
        </Stack>
      </Box>
    </Box>
  );
}
